import { PopupStates } from '@/enums/popup-states';
import { IGetters } from '@/interfaces/store/getters.interfaces';
import { IStudyStore } from '@/interfaces/store/study-store/study-store.store.interface';
import { FitLevel, ColorLevel } from 'interfaces';
import { StudentField, IBudget } from '@studyportals/studentdomain';
import { state } from './state';
import { store } from './store';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';

const getters: IGetters = {
	isReady: () => store.state.isReady,
	activeStudyId: (): number | null => store.state.activeStudyId,
	popupState: (): PopupStates | null => store.state.popupState,
	bestFitCompleteness: (): number | null => store.state.bestFitCompleteness,
	userLoggedIn: (): boolean => store.state.userLoggedIn,
	tuitionBudget: (): IBudget | null =>
		store.state.userData[StudentField.TUITION_BUDGET],
	activeMainDeterminant: (): ScoreDeterminantType | null =>
		store.state.activeMainDeterminant,
	activeSubDeterminant: (): ScoreDeterminantType | null =>
		store.state.activeSubDeterminant,
	isActiveDeterminant: (determinant: ScoreDeterminantType): boolean => {
		if (
			store.state.activeSubDeterminant === determinant ||
			store.state.activeMainDeterminant === determinant
		) {
			return true;
		}

		return false;
	},
	scoreText: (score: number): FitLevel | null => {
		if (score <= 30) {
			return FitLevel.BETTER_OPTIONS_AVAILABLE;
		}

		if (score <= 70) {
			return FitLevel.POTENTIAL_MATCH;
		}

		return FitLevel.GOOD_MATCH;
	},
	scoreColor: (score: number): ColorLevel | null => {
		if (score <= 30) {
			return ColorLevel.RED;
		}

		if (score <= 70) {
			return ColorLevel.ORANGE;
		}

		return ColorLevel.GREEN;
	},
	userNationality: (): number | null => store.state.userData[StudentField.NATIONALITY_COUNTRY_ID],
	userCountryOfResidence: (): number | null =>
		store.state.userData[StudentField.RESIDENCE_COUNTRY_ID],
	currency: (): string => store.state.userData[StudentField.CURRENCY],
	livingBudget: (): IBudget | null =>
		store.state.userData[StudentField.LIVING_BUDGET],
	workExperience: (): string | null =>
		store.state.userData[StudentField.WORK_EXPERIENCE],
	gpa: (): object | null => store.state.userData[StudentField.GPA],
	getStudyStore: (studyId?: number | null): IStudyStore | null => {
		if (!studyId) {
			return null;
		}

		return state.studyStores?.get(studyId) ?? null;
	},
	getActiveStudyStore: (): IStudyStore | null => {
		const activeStudy = store.getters.activeStudyId();

		return store.getters.getStudyStore(activeStudy);
	},
	getAllStudyStores: (): Map<number, IStudyStore> => state.studyStores,
};

export { getters };
